<add-to-team-form
  [searchMatches]="staff$ | async"
  (searchString)="searchStaff($event)"
  (cancel)="cancelPressed()"
  (addToTeam)="addToTeam($event)"
></add-to-team-form>
